import React, { Component } from 'react';
import ReactDOM from 'react-dom';
class Portal extends Component
 { constructor(props) 
    { super(props); this.portalRoot = document.getElementById('portal');
        this.el = document.createElement('div'); 
    }
    componentDidMount() {
        this.portalRoot.appendChild(this.el); 
    } 
    componentWillUnmount() { 
        this.portalRoot.removeChild(this.el); 
    } 
    render() { 
        return ReactDOM.createPortal( this.props.children, this.el ); 
    } 
} 
export default Portal